import { AccountSettings } from "@aws-amplify/ui-react";

function ChangePassword() {
  const handleSuccess = () => {
    alert("password is successfully changed!");
  };

  return <AccountSettings.ChangePassword onSuccess={handleSuccess} />;
}

export default ChangePassword;
